import { put, takeLatest } from "redux-saga/effects";

import axios from "axios";

import {
  qiuzApi,
  exerciseApi,
  simDetailsApi,
} from "../../../utility/api/apiList";


import singleSimDetailType from "./singleSimDetailType";
import {
  successFetchedExercise,
  successFetchedQuiz,
  successFetchedSingleSimDetail,
  failureFetchedExercise,
  failureFetchedSingleSimDetail,
  failureFetchedQuiz,
} from "./singleSimDetailAction";

export function* startfetchingSingleSimDetail(action) {
  try {
    const response = yield axios.get(`${simDetailsApi}${action.id}/`);
    yield (document.title = response.data.name);
    const handlesuccess = yield put(successFetchedSingleSimDetail(response.data));
    let id = response.data.id;
    if (response.data.is_exercise) {
      yield put({
        type: singleSimDetailType.START_FETCHING_EXERCISE_DETAILS,
        id,
      });
    }
    if (response.data.is_quiz) {
      yield put({
        type: singleSimDetailType.START_FETCHING_QUIZ_DETAILS,
        id,
      });
    }
  } catch (error) {
    const handlefailed = yield put(
      failureFetchedSingleSimDetail(error.response.data.non_field_errors[0])
    );
  }
}

export function* fetchSingleSimDetail() {
  yield takeLatest(
    singleSimDetailType.START_FETCHING_SINGLE_SIM_DETAILS,
    startfetchingSingleSimDetail
  );
}

//exercise

export function* startfetchingExerciseSim(action) {
  try {
    const response = yield axios.get(`${exerciseApi}${action.id}/`);
    const handlesuccess = yield put(successFetchedExercise(response.data));
  } catch (error) {
    const handlefailed = yield put(
      failureFetchedExercise(
        (error.response.data?.non_field_errors &&
          error.response.data?.non_field_errors[0]) ||
          error.response.data.details
      )
    );
  }
}

export function* fetchExerciseSim() {
  yield takeLatest(
    singleSimDetailType.START_FETCHING_EXERCISE_DETAILS,
    startfetchingExerciseSim
  );
}

//quiz

export function* startfetchingQuiz(action) {
  try {
    const response = yield axios.get(`${qiuzApi}?sim_id=${action.id}`);
    const handlesuccess = yield put(successFetchedQuiz(response.data));
  } catch (error) {
    const handlefailed = yield put(
      failureFetchedQuiz(error.response.data.non_field_errors[0])
    );
  }
}

export function* fetchQuiz() {
  yield takeLatest(
    singleSimDetailType.START_FETCHING_QUIZ_DETAILS,
    startfetchingQuiz
  );
}
